import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE, LOGOUT
} from '../actions/actionTypes';
import LocalStorageWrapper from "../lib/localStorageWrapper";

const initState = {
    isFetching: false,
    isAuthenticated: !!LocalStorageWrapper.getItem('accessToken'),
    errorMessage: '',
    accessToken: LocalStorageWrapper.getItem('accessToken'),
};

const authReducer = (state = initState, action) => {
    switch (action.type) {
    case LOGIN_REQUEST:
        return Object.assign({}, state, {
            isFetching: true,
            errorMessage: ''
        });
    case LOGIN_SUCCESS:
        return Object.assign({}, state, {
            isFetching: false,
            isAuthenticated: true,
            errorMessage: '',
            accessToken: action.accessToken,
        });
    case LOGIN_FAILURE:
        return Object.assign({}, state, {
            isFetching: false,
            isAuthenticated: false,
            errorMessage: action.message,
        });
    case LOGOUT:
        return Object.assign({}, state, {
            isAuthenticated: false,
        });
    default:
        return state;
    }
};

export default authReducer;
